import Http from "../util/Http";

class PointApi {
    static async getPointHistory(page, isTotalCount = false) {
        const queryString = new URLSearchParams({
            page,
            size: 30,
            isTotalCount
        }).toString();
        const res = await Http.get(`/point/history?${queryString}`);
        return res || [];
    }

}

export default PointApi;